import {Component} from '@angular/core';
import {PropertyFilterGroup} from '../../model/property-type-group.model';
import {
  LETTER_A,
  LETTER_B,
  LETTER_C,
  LETTER_D,
  LETTER_E,
  LETTER_F,
  LETTER_G,
  LETTER_H,
  LETTER_L,
  LETTER_M,
  LETTER_O, LETTER_P, LETTER_Q, LETTER_R, LETTER_S, LETTER_T, LETTER_V
} from '../../const/more-type';
import {CheckboxListFilter} from '../checkbox-list-filter';
import {FormBuilder} from '@angular/forms';
import {HomeSearchFiltersAnalyticsHandler} from '../../home-search-filters-analytics-handler';
import { toKebabCase } from 'src/app/core/helpers/string.healper';

@Component({
  selector: 'lps-more-type-filter',
  templateUrl: './more-type-filter.component.html'
})
export class MoreTypeFilterComponent extends CheckboxListFilter {
  filters: PropertyFilterGroup[] = [
    {groupName: 'A', options: LETTER_A},
    {groupName: 'B', options: LETTER_B},
    {groupName: 'C', options: LETTER_C},
    {groupName: 'D', options: LETTER_D},
    {groupName: 'E', options: LETTER_E},
    {groupName: 'F', options: LETTER_F},
    {groupName: 'G', options: LETTER_G},
    {groupName: 'H', options: LETTER_H},
    {groupName: 'L', options: LETTER_L},
    {groupName: 'M', options: LETTER_M},
    {groupName: 'O', options: LETTER_O},
    {groupName: 'P', options: LETTER_P},
    {groupName: 'Q', options: LETTER_Q},
    {groupName: 'R', options: LETTER_R},
    {groupName: 'S', options: LETTER_S},
    {groupName: 'T', options: LETTER_T},
    {groupName: 'V', options: LETTER_V},
  ].map(v => ({...v, options: v.options.map(o => ({...o, value: toKebabCase(o.value)}))}));

  constructor(fb: FormBuilder, googleAnalyticsEventManager: HomeSearchFiltersAnalyticsHandler) {
    super(fb, googleAnalyticsEventManager);
  }
}
